"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var cryptoUtils_1 = require("./cryptoUtils");

var NodeCryptoAesCipher =
/*#__PURE__*/
function () {
  function NodeCryptoAesCipher(createCipher, createDecipher) {
    _classCallCheck(this, NodeCryptoAesCipher);

    this.createCipher = createCipher;
    this.createDecipher = createDecipher;
  }

  _createClass(NodeCryptoAesCipher, [{
    key: "encrypt",
    value: function encrypt(algorithm, key, iv, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var cipher, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(algorithm !== 'aes-128-cbc' && algorithm !== 'aes-256-cbc')) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Unsupported cipher algorithm \"".concat(algorithm, "\""));

              case 2:
                cipher = this.createCipher(algorithm, key, iv);
                result = Buffer.concat([cipher.update(data), cipher.final()]);
                return _context.abrupt("return", Promise.resolve(result));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "decrypt",
    value: function decrypt(algorithm, key, iv, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var cipher, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(algorithm !== 'aes-128-cbc' && algorithm !== 'aes-256-cbc')) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Unsupported cipher algorithm \"".concat(algorithm, "\""));

              case 2:
                cipher = this.createDecipher(algorithm, key, iv);
                result = Buffer.concat([cipher.update(data), cipher.final()]);
                return _context2.abrupt("return", Promise.resolve(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return NodeCryptoAesCipher;
}();

exports.NodeCryptoAesCipher = NodeCryptoAesCipher;

var WebCryptoAesCipher =
/*#__PURE__*/
function () {
  function WebCryptoAesCipher(subtleCrypto) {
    _classCallCheck(this, WebCryptoAesCipher);

    this.subtleCrypto = subtleCrypto;
  }

  _createClass(WebCryptoAesCipher, [{
    key: "encrypt",
    value: function encrypt(algorithm, key, iv, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var algo, length, cryptoKey, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(algorithm === 'aes-128-cbc')) {
                  _context3.next = 5;
                  break;
                }

                algo = 'AES-CBC';
                length = 128;
                _context3.next = 11;
                break;

              case 5:
                if (!(algorithm === 'aes-256-cbc')) {
                  _context3.next = 10;
                  break;
                }

                algo = 'AES-CBC';
                length = 256;
                _context3.next = 11;
                break;

              case 10:
                throw new Error("Unsupported cipher algorithm \"".concat(algorithm, "\""));

              case 11:
                _context3.next = 13;
                return this.subtleCrypto.importKey('raw', key, {
                  name: algo,
                  length: length
                }, false, ['encrypt']);

              case 13:
                cryptoKey = _context3.sent;
                _context3.next = 16;
                return this.subtleCrypto.encrypt({
                  name: algo,
                  iv: iv
                }, cryptoKey, data);

              case 16:
                result = _context3.sent;
                return _context3.abrupt("return", Buffer.from(result));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "decrypt",
    value: function decrypt(algorithm, key, iv, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var algo, length, cryptoKey, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(algorithm === 'aes-128-cbc')) {
                  _context4.next = 5;
                  break;
                }

                algo = 'AES-CBC';
                length = 128;
                _context4.next = 11;
                break;

              case 5:
                if (!(algorithm === 'aes-256-cbc')) {
                  _context4.next = 10;
                  break;
                }

                algo = 'AES-CBC';
                length = 256;
                _context4.next = 11;
                break;

              case 10:
                throw new Error("Unsupported cipher algorithm \"".concat(algorithm, "\""));

              case 11:
                _context4.next = 13;
                return this.subtleCrypto.importKey('raw', key, {
                  name: algo,
                  length: length
                }, false, ['decrypt']);

              case 13:
                cryptoKey = _context4.sent;
                _context4.next = 16;
                return this.subtleCrypto.decrypt({
                  name: algo,
                  iv: iv
                }, cryptoKey, data);

              case 16:
                result = _context4.sent;
                return _context4.abrupt("return", Buffer.from(result));

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return WebCryptoAesCipher;
}();

exports.WebCryptoAesCipher = WebCryptoAesCipher;

function createCipher() {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var cryptoLib;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return cryptoUtils_1.getCryptoLib();

          case 2:
            cryptoLib = _context5.sent;

            if (!(cryptoLib.name === 'subtleCrypto')) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", new WebCryptoAesCipher(cryptoLib.lib));

          case 7:
            return _context5.abrupt("return", new NodeCryptoAesCipher(cryptoLib.lib.createCipheriv, cryptoLib.lib.createDecipheriv));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

exports.createCipher = createCipher;